<template>
	<div style="padding:2px;">
		<div style=" width:1141px;margin:auto">
			<div style="font-size:18px;font-weight: 700;text-align: left; height:50px;line-height: 70px; border-bottom: 2px solid #ccc;">
				合作意向</div>
			<el-card class="box-card" shadow="never" style="margin-top:10px;">
				<div slot="header" style="text-align: left;">
					<span><i class="el-icon-truck"></i> 热销产品</span>
				</div>
				<div style="display:flex;flex-direction: row;flex-wrap: wrap;justify-content: space-between;">
					<div>
						<el-card :body-style="{ padding: '0px' }">
							<img style="width:250px;height:250px;" src="../../assets/Product/6347a8512b844.jpg">
							<div style="padding: 14px;">
								<span>建筑用钢</span>
							</div>
						</el-card>
					</div>
					<div>
						<el-card :body-style="{ padding: '0px' }">
							<img style="width:250px;height:250px;" src="../../assets/Product/63477cde64ded.jpg">
							<div style="padding: 14px;">
								<span>汽车用钢</span>
							</div>
						</el-card>
					</div>
					<div>
						<el-card :body-style="{ padding: '0px' }">
							<img style="width:250px;height:250px;" src="../../assets/Product/63477d0168a1a.jpg">
							<div style="padding: 14px;">
								<span>汽车用钢</span>
							</div>
						</el-card>
					</div>
					<div>
						<el-card :body-style="{ padding: '0px' }">
							<img style="width:250px;height:250px;" src="../../assets/Product/634777bfaae75.jpg">
							<div style="padding: 14px;">
								<span>家电用钢</span>
							</div>
						</el-card>
					</div>
				</div>
			</el-card>
			<el-card class="box-card" shadow="never" style="margin-top:10px;">
				<div slot="header" style="text-align: left;">
					<span><i class="el-icon-s-shop"></i> 最新上架</span>
				</div>
				<div style="display:flex;flex-direction: row;flex-wrap: wrap;justify-content: space-between;">
					<div>
						<el-card :body-style="{ padding: '0px' }">
							<img style="width:250px;height:250px;" src="../../assets/Product/63477cde64ded.jpg">
							<div style="padding: 14px;">
								<span>汽车用钢</span>
							</div>
						</el-card>
					</div>
					<div>
						<el-card :body-style="{ padding: '0px' }">
							<img style="width:250px;height:250px;" src="../../assets/Product/63477d0168a1a.jpg">
							<div style="padding: 14px;">
								<span>汽车用钢</span>
							</div>
						</el-card>
					</div>
					<div>
						<el-card :body-style="{ padding: '0px' }">
							<img style="width:250px;height:250px;" src="../../assets/Product/6347a8512b844.jpg">
							<div style="padding: 14px;">
								<span>建筑用钢</span>
							</div>
						</el-card>
					</div>
					<div>
						<el-card :body-style="{ padding: '0px' }">
							<img style="width:250px;height:250px;" src="../../assets/Product/634777bfaae75.jpg">
							<div style="padding: 14px;">
								<span>家电用钢</span>
							</div>
						</el-card>
					</div>
				</div>
			</el-card>
		</div>
		<div style=" width:1141px;margin:auto">
			<el-card class="box-card" shadow="never" style="margin-top:10px;">
				<div slot="header" style="text-align: left;">
					<span><i class="el-icon-connection"></i> 合作意向</span>
				</div>
				<div style=" width:1141px;margin:auto">
					<el-form :model="form" :rules="rules" ref="form" size="mini" label-width="80px">
						<el-form-item label="所在地区" prop="region" style="text-align: left;">
							<el-input v-model="form.region" style="width:300px"></el-input>
						</el-form-item>
						<el-form-item label="合作方式" prop="hzfsid" style="text-align: left;">
							<el-select v-model="form.hzfsid">
								<el-option v-for="item in hzfs" :key="item.HZFSID" :label="item.HZFS"
									:value="item.HZFSID"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="合作意向" prop="hzyx">
							<el-input type="textarea" rows="8" placeholder="请输入合作意向的简要内容" v-model="form.hzyx"></el-input>
						</el-form-item>
						<el-form-item style="text-align: left;">
							<el-button type="primary" :disabled="form.hzyx.length<1" @click="onSubmit('form')">提交意向</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-card>
		</div>
		<div
			style="width:100%;margin-top: 10px; background-color: #efefef;text-align: center; height: 50px;line-height: 50px;border-top: 1px solid #ccc; margin-bottom: 2px;">
			2022 重庆市离离科技有限公司 备案 渝ICP备2020011628号-1
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					region: '',
					hzfsid: '',
					hzyx: ''
				},
				rules: {
					region: [{
						required: true,
						message: '请输入区域',
						trigger: 'blur'
					}],
					hzfsid: [{
						required: true,
						message: '请选择合作方式',
						trigger: 'blur'
					}],
					hzyx: [{
						required: true,
						message: '请输入意向内容',
						trigger: 'blur'
					}]
				},
				custid: '01BF1ABC8EB444BFA3C39F18C1935164',
				tjyx: false,
				hzfs: [],
			};
		},
		created() {
			this.getHZFS()
			this.custid=JSON.parse(localStorage.getItem('userInfo')).CUSTID
		},
		methods: {
			onSubmit(formName) {
				let self = this
				if (self.custid == '') {
					self.$message.error('请登录后再提交');
					return
				}
				self.$refs[formName].validate((valid) => {
					if (valid) {
						self.doSubmit();
					} else {
						return false;
					}
				});

			},
			doSubmit() {
				let self = this;
				self.tjyx = true;
				var para = {
					"custid": self.custid,
					"hzfsid": self.form.hzfsid,
					"szdq": self.form.region,
					"hzyx": self.form.hzyx
				}
				let url = 'http://www.liligc.com/NWCenter/dlCustTest?action=SaveHZYX'
				self.axios.get(url, {
					params: {
						"para": JSON.stringify(para)
					}
				}).then(function(res) {
					if (res.data.result) {
						self.$message.success('意向提交成功，我们将尽快回复您');
					} else {
						self.$message.error('服务不可用');
					}
				}).catch(function(err) {
					this.$message.error('服务不可用：' + err);
				}).finally(() => {
					self.$refs['form'].resetFields();
					self.tjyx = false
				});
			},
			getHZFS() {
				let self = this
				let url = 'http://www.liligc.com/NWCenter/dlCustTest?action=GetHZFS'
				self.axios.get(url).then(function(res) {
					if (res.data.result) {
						self.hzfs = res.data.ja
					} else {
						this.$message.error('发生错误');
					}
				}).catch(function(err) {
					this.$message.error(err);
				});
			}
		}
	};
</script>

<style lang="less" scoped>

</style>
